module.exports = __webpack_public_path__ + "static/img/xj0515.4944951.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj0515.jpg
// module id = kPgB
// module chunks = 0